class CharacterLimitInput {
  optionWrapper; // div with option input and options notification
  inputElement; // input option in optionWrapper
  limit; // the last number after the slash which means the limit

  constructor(optionWrapper) {
    this.optionWrapper = optionWrapper;

    this.inputElement = this.optionWrapper.querySelector('.au-inputs__text.au-options__text-input');

    const notificationElement = this.optionWrapper.querySelector('.au-options__notification > div');
    this.limit = +(notificationElement.innerText.split('/')[1]);
  }

  subscribe() {
    const subscribeConditions = {
      hasOptionWrapper: !!this.optionWrapper,
      hasInputElement: !!this.inputElement,
      hasLimit: !!this.limit,
    }
    if (subscribeConditions.hasOptionWrapper === false) throw new Error('Option wrapper not found. Perhaps the editor has not loaded?');
    if (subscribeConditions.hasInputElement === false) throw new Error('Input element not found. Perhaps the editor has not loaded?'); 
    if (subscribeConditions.hasLimit === false) throw new Error('Limit not found. Perhaps the editor has not loaded?'); 
  
    this.inputElement.addEventListener('change', (event) => this.fix(event));
    this.inputElement.addEventListener('input', (event) => this.fix(event));
    this.inputElement.addEventListener('focus', (event) => this.fix(event));
  }

  fix(event) {
    const arrayInputValue = event.target.value.split('');
    const lenInputValue = arrayInputValue.length;
    
    if (lenInputValue > this.limit) {
      const newArrayInputValue = arrayInputValue.splice(0, this.limit);
      event.target.value = newArrayInputValue.join('');
    }
  }
}